import { useAuthContext } from 'context/AuthContext'

export function useCouponsAccess() {
  const { capabilities } = useAuthContext()
  return capabilities?.['coupons']
}

export function useCanUseCoupons(): boolean {
  return useCouponsAccess()?.has_access ?? false
}
